module.exports = __webpack_public_path__ + "files/9dc21d51229830779498edf9c18a40fa.png";